import { GameMetaAction, GameMetaActionTypes, GameMetaType } from "../types";

const initialState: GameMetaType = {
  gameId: "",
  homeTeam: {
    teamId: "",
    nick: "",
    totalWins: 0,
    totalLoss: 0,
    totalTies: 0,
    pointTotal: 0,
  },
  visitorTeam: {
    teamId: "",
    nick: "",
    totalWins: 0,
    totalLoss: 0,
    totalTies: 0,
    pointTotal: 0,
  },
};

export const gameMeta = (state = initialState, action: GameMetaActionTypes) => {
  switch (action.type) {
    case GameMetaAction.SET_GAME_META:
      return action.gameMeta;
    default:
      return state;
  }
};
